import { toastr } from 'react-redux-toastr';
import branditRails from '../../../../api/brandit_rails';
import { setPagesAction, setPageAction, addPageAction, updatePageAction, removePageAction, setPagesStatusAction, setPageCurrentStatusAction, setPagesErrorsAction, clearPagesErrorsAction } from './pages.actions';
export const fetchPages = ({ portalId }) => async (dispatch) => {
    try {
        dispatch(setPagesStatusAction('loading'));
        dispatch(clearPagesErrorsAction());
        const { data: pages } = await branditRails.get('/pages', {
            params: { portal_id: portalId }
        });
        const pagesById = pages.reduce((acc, page) => {
            acc[page.id] = page;
            return acc;
        }, {});
        dispatch(setPagesAction(pagesById));
        dispatch(setPagesStatusAction('succeeded'));
        return pages;
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        dispatch(setPagesErrorsAction({ message: errorMessage }));
        dispatch(setPagesStatusAction('failed'));
        toastr.error('Error', errorMessage);
    }
};
export const fetchPage = (id) => async (dispatch) => {
    try {
        dispatch(setPageCurrentStatusAction('loading'));
        dispatch(clearPagesErrorsAction());
        const { data: page } = await branditRails.get(`/pages/${id}`);
        dispatch(setPageAction(page));
        dispatch(setPageCurrentStatusAction('succeeded'));
        return page;
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        dispatch(setPagesErrorsAction({ message: errorMessage }));
        dispatch(setPageCurrentStatusAction('failed'));
        toastr.error('Error', errorMessage);
    }
};
export const createPage = ({ portalId, data, shouldOverride }) => async (dispatch) => {
    try {
        dispatch(setPageCurrentStatusAction('loading'));
        dispatch(clearPagesErrorsAction());
        const { data: page } = await branditRails.request({
            url: '/pages',
            method: 'POST',
            data: { ...data, portal_id: portalId, override_home_locations: shouldOverride },
            params: { override_home_locations: shouldOverride }
        });
        dispatch(addPageAction(page));
        dispatch(setPageAction(page));
        dispatch(setPageCurrentStatusAction('succeeded'));
        toastr.success('Success', 'Page created successfully');
        return page;
    }
    catch (err) {
        const errorMessage = (err.response?.data?.message || err.message);
        const errCode = err.response?.data?.code || err?.code || undefined;
        const errStatus = err.response?.status || err?.status || undefined;
        dispatch(setPagesErrorsAction({
            message: errorMessage,
            code: errCode,
            status: errStatus
        }));
        dispatch(setPageCurrentStatusAction('failed'));
        // if (errCode !== 'home_page_conflict') toastr.error('Error', errorMessage)
        throw err;
    }
};
export const updatePage = ({ id, data, shouldOverride }) => async (dispatch) => {
    try {
        dispatch(setPageCurrentStatusAction('loading'));
        dispatch(clearPagesErrorsAction());
        const { data: page } = await branditRails.request({
            url: `/pages/${id}`,
            method: 'PATCH',
            data,
            params: { override_home_locations: shouldOverride }
        });
        dispatch(updatePageAction(page));
        dispatch(setPageAction(page));
        dispatch(setPageCurrentStatusAction('succeeded'));
        toastr.success('Success', 'Page updated successfully');
        return page;
    }
    catch (err) {
        const errorMessage = (err.response?.data?.message || err.message);
        const errCode = err.response?.data?.code || err?.code || undefined;
        const errStatus = err.response?.status || err?.status || undefined;
        dispatch(setPagesErrorsAction({
            message: errorMessage,
            code: errCode,
            status: errStatus
        }));
        dispatch(setPageCurrentStatusAction('failed'));
        // if (errCode !== 'home_page_conflict') toastr.error('Error', errorMessage)
        throw err;
    }
};
export const deletePage = (id) => async (dispatch) => {
    try {
        await branditRails.delete(`/pages/${id}`);
        dispatch(removePageAction(Number(id)));
        toastr.success('Success', 'Page deleted successfully');
    }
    catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        dispatch(setPagesErrorsAction({ message: errorMessage }));
        dispatch(setPagesStatusAction('failed'));
        toastr.error('Error', errorMessage);
    }
};
